"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.draw = draw;
exports.fade = fade;
exports["default"] = void 0;
var amplitude = 30;

function getSourceRect(image, srcW, srcH) {
  var destW = image.naturalWidth;
  var destH = image.naturalHeight;
  var scale = Math.min(destW / srcW, destH / srcH);
  var scaledSrcW = srcW * scale;
  var scaledSrcH = srcH * scale;
  var startX = (destW - scaledSrcW) * 0.5;
  var startY = (destH - scaledSrcH) * 0.5;
  return {
    x: startX,
    y: startY,
    w: scaledSrcW,
    h: scaledSrcH
  };
}

function sqsin(value) {
  var rest = value % 2;
  if (rest > 1) return 2 - rest;
  return rest;
}

function drawImage(ctx, image, flip, x, y, w, h, time, speed) {
  ctx.save();
  var hW = w / 2;
  var hH = h / 2;
  var sourceRect = getSourceRect(image, w, h);
  ctx.translate(x, y);
  ctx.translate(hW, hH);
  ctx.scale(flip ? -1 : 1, 1);
  var scaleFactor = amplitude / image.naturalWidth;
  var anim = sqsin(time / 7000 * speed);
  var stepX = image.naturalWidth * scaleFactor;
  var stepY = image.naturalHeight * scaleFactor;
  var scaleAnim = 1 - anim * 0.1;
  ctx.drawImage(image, sourceRect.x + stepX - anim * amplitude, sourceRect.y + stepY, (sourceRect.w - stepX) * scaleAnim, (sourceRect.h - stepY) * scaleAnim, -hW, -hH, w, h);
  ctx.restore();
}

function draw(context, size, image, time) {
  var type = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 3;
  var speed = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0.3;
  if (!image) return;
  var width = size.width,
      height = size.height;
  var w = width / type;
  context.clearRect(0, 0, width, height);

  for (var i = 0; i < type; i += 1) {
    drawImage(context, image, i % 2 === 1, w * i, 0, w, height, time, speed);
  }
}

function fade(context, size, opacity) {
  var width = size.width,
      height = size.height;
  context.fillStyle = "rgba(0,0,0,".concat(opacity, ")");
  context.fillRect(0, 0, width, height);
}

var _default = draw;
exports["default"] = _default;